





















































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetExamResultList$ } from "@/request/shezhenjiaoxue";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../components/left-nav.vue";
import ExamTable from "./exam-list.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    ExamTable,
    Pagination,
  },
})
export default class SzksResultList extends Vue {
  private filters: any = {
    search: "",
    current_page: 1,
    total_count: 0,
    page_count: 10,
    order_value: 0,
  };
  // 列表
  private exams: any[] = [];
  private setFilters() {
    localStorage.setItem("szksResultFilters", JSON.stringify(this.filters));
  }
  /**
   * @description 获得考试记录列表
   */
  private fetchExamResultList() {
    const params = _.cloneDeep(this.filters);
    GetExamResultList$(this, params).then((data: any) => {
      console.log(data);
      this.$set(this, "exams", data.replies);
      this.filters.total_count = data.total_count;
      this.setFilters();
    });
  }
  /**
   * @description 改变排序顺序
   */
  private changeOrderValue() {
    this.filters.order_value = this.filters.order_value === 0 ? 1 : 0;
    this.search();
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.current_page = 1;
    this.fetchExamResultList();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.current_page = val;
    this.fetchExamResultList();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const localFilters = localStorage.getItem("szksResultFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        search: "",
        current_page: 1,
        total_count: 0,
        page_count: 10,
        order_value: 0,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    this.fetchExamResultList();
  }
}
